/** Formats a number based on the provided locale and options.
 * @param value - The number to be formatted.
 * @param locale - The locale string used to format the number.
 * @param options - An object to specify formatting options such as style, currency, minimum/maximum fraction digits, etc.
 * @returns A string displaying the formatted number.
 */

export const formatNumber = ({
  value,
  locale,
  options = {},
}: {
  locale?: Locale;
  options?: Intl.NumberFormatOptions;
  value: number;
}): string => {
  return new Intl.NumberFormat(locale, options).format(value);
};
